(() => {
  if (window.CNBSizeGuideReady) return;
  window.CNBSizeGuideReady = true;
  const setUnit = (root, unit) => {
    if (!root) return;
    root.querySelectorAll('[data-cnb-size-unit]').forEach((button) => button.setAttribute('aria-pressed', button.dataset.cnbSizeUnit === unit ? 'true' : 'false'));
    root.querySelectorAll('[data-cnb-cm]').forEach((element) => { element.hidden = unit !== 'cm'; });
    root.querySelectorAll('[data-cnb-in]').forEach((element) => { element.hidden = unit !== 'in'; });
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cnb-size-open]');
    if (opener) {
      const dialog = document.querySelector(opener.dataset.cnbSizeOpen);
      if (dialog && typeof dialog.showModal === 'function') { setUnit(dialog, 'cm'); dialog.showModal(); }
      return;
    }
    const closer = event.target.closest('[data-cnb-size-close]');
    if (closer) { const dialog = closer.closest('dialog'); if (dialog) dialog.close(); return; }
    const unitButton = event.target.closest('[data-cnb-size-unit]');
    if (unitButton) { setUnit(unitButton.closest('.cnb-size-guide-dialog'), unitButton.dataset.cnbSizeUnit); return; }
    const dialog = event.target.closest('dialog.cnb-size-guide-dialog');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      if (outside) dialog.close();
    }
  });
})();
